import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQ = ({ question, answer }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-white p-5 rounded shadow-md">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex justify-between items-center text-left text-xl font-bold text-[#2b854c]"
      >
        {question}
        {open ? <FaChevronUp /> : <FaChevronDown />}
      </button>
      {open && <div className="mt-4 text-gray-700 text-base">{answer}</div>}
    </div>
  );
};

export default FAQ;
